// import { FileSpreadsheet, Printer } from "lucide-react";
// import React, { useCallback, useEffect, useMemo, useState } from "react";
// import "./DayBook.css";
// import axios from "axios";
// import { toast } from "react-toastify";

// const API_URL = "https://payyug.in/api";
// const PAGE_LIMIT = 200;

// const DayBook = () => {
//   const [date, setDate] = useState("");
//   const [appliedDate, setAppliedDate] = useState("");

//   const [dayBookData, setDayBookData] = useState([]);
//   const [totalDebit, setTotalDebit] = useState(0);
//   const [totalCredit, setTotalCredit] = useState(0);

//   const [maxLimit, setMaxLimit] = useState(0);
//   const [currentPage, setCurrentPage] = useState(1);

//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");
//   const [hasSearched, setHasSearched] = useState(false);

//   /* ================= FETCH ================= */
//   const fetchDayBookData = useCallback(async () => {
//     if (!appliedDate) return;

//     try {
//       setLoading(true);
//       setError("");

//       const token = localStorage.getItem("authToken");
//       const superAdminId = localStorage.getItem("adminuserId");

//       const res = await axios.get(`${API_URL}/report/day-book`, {
//         params: {
//           superAdminId,
//           // branchId: 66,
//           date: appliedDate,
//         },
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });

//       const vouchers = res?.data?.vouchers || [];

//       setDayBookData(vouchers);
//       setTotalDebit(res?.data?.totalDebit || 0);
//       setTotalCredit(res?.data?.totalCredit || 0);

//       setMaxLimit(Math.min(vouchers.length, PAGE_LIMIT));
//       setCurrentPage(1);
//     } catch (err) {
//       console.error(err);
//       setError(err?.response?.data?.message || "Failed to fetch day book");
//     } finally {
//       setLoading(false);
//     }
//   }, [appliedDate]);

//   /* ================= FILTER ================= */
//   const handleSubmit = (e) => {
//     e.preventDefault();

//     if (!date) {
//       toast.error("Please select Date");
//       return;
//     }

//     setAppliedDate(date);
//     setHasSearched(true);
//   };

//   /* ================= FETCH AFTER SEARCH ================= */
//   useEffect(() => {
//     if (hasSearched) fetchDayBookData();
//   }, [fetchDayBookData, hasSearched]);

//   /* ================= PAGINATION ================= */
//   const totalPages = Math.ceil(dayBookData.length / PAGE_LIMIT);

//   const paginatedData = useMemo(() => {
//     if (dayBookData.length <= PAGE_LIMIT) return dayBookData;

//     const start = (currentPage - 1) * PAGE_LIMIT;
//     const end = start + PAGE_LIMIT;
//     return dayBookData.slice(start, end);
//   }, [dayBookData, currentPage]);

//   /* ================= HELPERS ================= */
//   const splitEntries = (entries = []) => ({
//     drEntries: entries.filter((e) => e.factor === "dr"),
//     crEntries: entries.filter((e) => e.factor === "cr"),
//   });

// const remainingCount = Math.max(
//   PAGE_LIMIT - dayBookData.length,
//   0
// );



//   return (
//     <div className="dayBook-container">
//       <h1 className="dayBook-heading">Day Book (Closing Balance)</h1>

//       {/* FILTER */}
//       <div className="dayBook-top">
//         <form className="dayBook-form" onSubmit={handleSubmit}>
//           <div className="dayBook-form-section">
//             <div className="dayBook-form-input-fields">
//               <label>Date</label>
//               <input
//                 type="date"
//                 value={date}
//                 onChange={(e) => setDate(e.target.value)}
//               />
//             </div>
//           </div>

//           <div className="dayBook-form-submit-btn">
//             <button type="submit">
//               {loading ? "Loading..." : "Get Records"}
//             </button>
//           </div>
//         </form>
//       </div>

//       {/* DOWNLOAD */}
//       <div className="dayBook-pdf-download-btns">
//         <button>
//           <FileSpreadsheet size={15} /> Download Excel
//         </button>
//         <button>
//           <Printer size={15} /> Print
//         </button>
//       </div>

//       {/* REPORT */}
//       <div className="dayBook-report-section">
//         <h2>Ledgers</h2>
//         <p className="dayBook-record-limit">
//           MAXIMUM RECORDS SHOW LIMIT IS {PAGE_LIMIT} | REMAINING {remainingCount}
//         </p>

//         <div className="dayBook-report-table">
//           <table>
//             <thead>
//               <tr>
//                 <th>SN.</th>
//                 <th>Date</th>
//                 <th>Voucher No</th>
//                 <th>Voucher Type</th>
//                 <th>Narration</th>
//                 <th className="amount-head" style={{ width: "200px" }}>
//                   <div className="dayBook-th-data">
//                     <h4>Amount</h4>
//                     <div className="dayBook-th-amount">
//                       <span>DR</span>
//                       <span>CR</span>
//                     </div>
//                   </div>
//                 </th>
//                 <th>Status</th>
//               </tr>
//             </thead>

//             <tbody>
//               {!hasSearched ? (
//                 <tr>
//                   <td colSpan="7" style={{ textAlign: "center" }}>
//                     Please select filters and click Get Records
//                   </td>
//                 </tr>
//               ) : paginatedData.length ? (
//                 paginatedData.map((item, index) => {
//                   const { drEntries, crEntries } = splitEntries(item.entries);

//                   return (
//                     <tr key={item.id}>
//                       <td>
//                         {(currentPage - 1) * PAGE_LIMIT + index + 1}
//                       </td>
//                       <td>
//                         {item.date
//                           ? new Date(item.date).toLocaleDateString()
//                           : "-"}
//                       </td>
//                       <td>{item.voucherNo}</td>
//                       <td>{item.voucherType}</td>
//                       <td>{item.narration}</td>

//                       <td className="amount-row">
//                         <span>
//                           {drEntries.length
//                             ? drEntries.map((e, i) => (
//                                 <div key={i}>{e.debit}</div>
//                               ))
//                             : "0"}
//                         </span>
//                         <span>
//                           {crEntries.length
//                             ? crEntries.map((e, i) => (
//                                 <div key={i}>{e.credit}</div>
//                               ))
//                             : "0"}
//                         </span>
//                       </td>

//                       <td>{item.status || "-"}</td>
//                     </tr>
//                   );
//                 })
//               ) : (
//                 <tr>
//                   <td colSpan="7" style={{ textAlign: "center" }}>
//                     No results found
//                   </td>
//                 </tr>
//               )}

//               {hasSearched && dayBookData.length > 0 && (
//                 <tr className="totalRow">
//                   <td colSpan="5">TOTAL AMOUNT</td>
//                   <td>
//                     <div className="dayBook-th-amount">
//                       <p>{totalDebit}</p>
//                       <p>{totalCredit}</p>
//                     </div>
//                   </td>
//                   <td></td>
//                 </tr>
//               )}
//             </tbody>
//           </table>

//           {/* PAGINATION (ONLY IF > 200) */}
//           {dayBookData.length > PAGE_LIMIT && (
//             <div className="pagination">
//               <button
//                 disabled={currentPage === 1}
//                 onClick={() => setCurrentPage((p) => p - 1)}
//               >
//                 Prev
//               </button>

//               <span>
//                 Page {currentPage} of {totalPages}
//               </span>

//               <button
//                 disabled={currentPage === totalPages}
//                 onClick={() => setCurrentPage((p) => p + 1)}
//               >
//                 Next
//               </button>
//             </div>
//           )}

//           {error && <p className="error-text">{error}</p>}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default DayBook;




import React, { useCallback, useEffect, useMemo, useState } from "react";
import "./DayBook.css";
import axios from "axios";
import { toast } from "react-toastify";
import { FileSpreadsheet, FileText } from "lucide-react";
import * as XLSX from "xlsx";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";

const API_URL = "https://payyug.in/api";

// Helper function to safely convert image URL to Base64
const getBase64ImageFromUrl = async (imageUrl) => {
  if (!imageUrl) return null;
  try {
    const response = await fetch(imageUrl, { mode: "cors" });
    if (!response.ok) return null;
    const blob = await response.blob();
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = () => reject(null);
      reader.readAsDataURL(blob);
    });
  } catch (error) {
    console.error("Image loading failed:", error);
    return null;
  }
};

const DayBook = () => {
  const [date, setDate] = useState("");
  const [appliedDate, setAppliedDate] = useState("");
  const [branchId, setBranchId] = useState("");
  const [appliedBranchId, setAppliedBranchId] = useState("");

  const [branches, setBranches] = useState([]);
  const [dayBookData, setDayBookData] = useState([]);
  const [totalDebit, setTotalDebit] = useState(0);
  const [totalCredit, setTotalCredit] = useState(0);

  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [hasSearched, setHasSearched] = useState(false);
  const [company, setCompany] = useState(null);

  const superAdminId = useMemo(() => localStorage.getItem("adminuserId"), []);

  /* ================= FETCH COMPANY DETAILS ================= */
  useEffect(() => {
    const fetchCompany = async () => {
      try {
        const response = await fetch(
          `${API_URL}/get-company?superAdminId=${superAdminId}`
        );
        const data = await response.json();

        if (response.ok && data) {
          if (data.logo) {
            data.logoUrl = `https://payyug.in/${data.logo.replace(/^images\//, "")}`;
          }
          setCompany(data);
        }
      } catch (err) {
        console.error("Error fetching company details:", err);
      }
    };

    if (superAdminId) fetchCompany();
  }, [superAdminId]);

  /* ================= FETCH BRANCHES ================= */
  useEffect(() => {
    const fetchBranches = async () => {
      try {
        const res = await axios.get(`${API_URL}/get-branch`, {
          params: { SuperAdminId: superAdminId, limit: "all" },
        });
        setBranches(res?.data?.branches || []);
      } catch (err) {
        console.error("Fetch Branch Error:", err);
      }
    };
    fetchBranches();
  }, [superAdminId]);

  /* ================= FETCH DAY BOOK ================= */
  const fetchDayBookData = useCallback(async () => {
    if (!appliedDate) return;

    try {
      setLoading(true);
      setError("");

      const token = localStorage.getItem("authToken");

      const params = {
        superAdminId,
        date: appliedDate,
      };

      if (appliedBranchId) {
        params.branchId = appliedBranchId;
      }

      const res = await axios.get(`${API_URL}/report/day-book`, {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const vouchers = res?.data?.vouchers || [];

      setDayBookData(vouchers);
      setTotalDebit(res?.data?.totalDebit || 0);
      setTotalCredit(res?.data?.totalCredit || 0);
      setCurrentPage(1);
    } catch (err) {
      console.error(err);
      setError(err?.response?.data?.message || "Failed to fetch day book");
      setDayBookData([]);
    } finally {
      setLoading(false);
    }
  }, [appliedDate, appliedBranchId, superAdminId]);

  /* ================= FILTER SUBMIT ================= */
  const handleSubmit = (e) => {
    e.preventDefault();

    if (!date) {
      toast.error("Please select Date");
      return;
    }

    setAppliedDate(date);
    setAppliedBranchId(branchId);
    setHasSearched(true);
  };

  useEffect(() => {
    if (hasSearched) fetchDayBookData();
  }, [fetchDayBookData, hasSearched]);

  /* ================= PAGINATION LOGIC ================= */
  const isShowAll = rowsPerPage === "ALL";
  const limitValue = isShowAll ? dayBookData.length || 1 : Number(rowsPerPage);
  const totalPages = Math.ceil(dayBookData.length / limitValue) || 1;

  const paginatedData = useMemo(() => {
    if (isShowAll || dayBookData.length <= limitValue) return dayBookData;

    const start = (currentPage - 1) * limitValue;
    const end = start + limitValue;
    return dayBookData.slice(start, end);
  }, [dayBookData, currentPage, limitValue, isShowAll]);

  const splitEntries = (entries = []) => ({
    drEntries: entries.filter((e) => e.factor === "dr"),
    crEntries: entries.filter((e) => e.factor === "cr"),
  });

  /* ================= EXPORT TO EXCEL ================= */
  const exportToExcel = () => {
    if (dayBookData.length === 0) {
      toast.error("No data available to export");
      return;
    }

    const exportList = dayBookData.map((item, index) => {
      const { drEntries, crEntries } = splitEntries(item.entries);
      const drAmount = drEntries.map((e) => e.debit || 0).join(", ") || 0;
      const crAmount = crEntries.map((e) => e.credit || 0).join(", ") || 0;

      return {
        "SN": index + 1,
        "Date": item.date ? new Date(item.date).toLocaleDateString() : "-",
        "Voucher No": item.voucherNo || "N/A",
        "Voucher Type": item.voucherType || "N/A",
        "Narration": item.narration || "-",
        "Debit (DR)": drAmount,
        "Credit (CR)": crAmount,
        "Status": item.status || "-",
      };
    });

    const worksheet = XLSX.utils.json_to_sheet(exportList);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Day Book");
    XLSX.writeFile(workbook, `Day_Book_${appliedDate || "Report"}.xlsx`);
  };

  /* ================= EXPORT TO PDF ================= */
  const exportToPDF = async () => {
    if (!dayBookData || dayBookData.length === 0) {
      toast.error("No data available to export");
      return;
    }

        const doc = new jsPDF({
      orientation: "p",
      unit: "mm",
      format: "a4",
      compress: true,
    });
    const pageWidth = doc.internal.pageSize.width;

    // Logo Section
    const logoX = 15;
    const logoY = 12;
    const logoSize = 22;

    if (company?.logoUrl) {
      const base64Logo = await getBase64ImageFromUrl(company.logoUrl);
      if (base64Logo) {
        try {
          const isJpeg =
            company.logoUrl.toLowerCase().includes(".jpg") ||
            company.logoUrl.toLowerCase().includes(".jpeg");
          const format = isJpeg ? "JPEG" : "PNG";

          doc.addImage(base64Logo, format, logoX, logoY, logoSize, logoSize);
        } catch (err) {
          console.warn("Logo draw error:", err);
        }
      }
    }

    // Company Details
    const nameX = logoX + logoSize + 8;
    const nameY = 16;
    const nameMaxWidth = pageWidth - nameX - 15;

    doc.setFont("helvetica", "bold");
    doc.setFontSize(13);
    doc.setTextColor(2, 44, 58);

    const companyNameText = doc.splitTextToSize(
      (company?.name || "COMPANY NAME").toUpperCase(),
      nameMaxWidth
    );
    doc.text(companyNameText, nameX, nameY);

    let currentY = nameY + companyNameText.length * 5;

    doc.setFont("helvetica", "normal");
    doc.setFontSize(9);
    doc.setTextColor(80, 80, 80);

    const addressText = doc.splitTextToSize(
      company?.address || "Company Address",
      nameMaxWidth
    );
    doc.text(addressText, nameX, currentY);
    currentY += addressText.length * 4;

    doc.text(`Email: ${company?.email || "-"}`, nameX, currentY);
    currentY += 4;

    doc.text(`Phone: ${company?.contact || "-"}`, nameX, currentY);
    currentY += 10;

    // Divider Line
    doc.setDrawColor(220, 220, 220);
    doc.setLineWidth(0.3);
    doc.line(10, currentY, pageWidth - 10, currentY);

    // Title
    currentY += 8;
    doc.setFont("helvetica", "bold");
    doc.setFontSize(12);
    doc.setTextColor(0, 0, 0);
    doc.text(`Day Book Report (${appliedDate})`, pageWidth / 2, currentY, {
      align: "center",
    });

    // Table Data
    const tableColumn = [
      "SN",
      "Date",
      "Voucher No",
      "Voucher Type",
      "Narration",
      "DR",
      "CR",
      "Status",
    ];

    const tableRows = dayBookData.map((item, index) => {
      const { drEntries, crEntries } = splitEntries(item.entries);
      const drAmount = drEntries.map((e) => e.debit || 0).join(", ") || "0";
      const crAmount = crEntries.map((e) => e.credit || 0).join(", ") || "0";

      return [
        index + 1,
        item.date ? new Date(item.date).toLocaleDateString() : "-",
        item.voucherNo || "-",
        item.voucherType || "-",
        item.narration || "-",
        drAmount,
        crAmount,
        item.status || "-",
      ];
    });

    // Add Total Row at Bottom
    tableRows.push([
      "",
      "",
      "",
      "",
      "TOTAL AMOUNT",
      String(totalDebit),
      String(totalCredit),
      "",
    ]);

    autoTable(doc, {
      startY: currentY + 6,
      head: [tableColumn],
      body: tableRows,
      theme: "grid",
      styles: {
        fontSize: 8,
        cellPadding: 3,
        halign: "center",
        valign: "middle",
        textColor: [50, 50, 50],
      },
      headStyles: {
        fillColor: [2, 44, 58],
        textColor: [255, 255, 255],
        fontStyle: "bold",
        fontSize: 8.5,
        halign: "center",
      },
      alternateRowStyles: {
        fillColor: [248, 250, 252],
      },
      margin: { left: 10, right: 10, top: 10, bottom: 15 },

      didDrawPage: function (data) {
        const pWidth = doc.internal.pageSize.width;
        const pHeight = doc.internal.pageSize.height;

        doc.setDrawColor(0, 0, 0);
        doc.setLineWidth(0.2);
        doc.rect(8, 8, pWidth - 16, pHeight - 16);

        doc.setFontSize(8);
        doc.setTextColor(120, 120, 120);
        doc.text(
          `Page ${data.pageNumber} of ${doc.internal.getNumberOfPages()}`,
          pWidth / 2,
          pHeight - 11,
          { align: "center" }
        );
      },
    });

    doc.save(`Day_Book_${appliedDate}.pdf`);
  };

  return (
    <div className="dayBook-container">
      <h1 className="dayBook-heading">Day Book (Closing Balance)</h1>

      {/* FILTER SECTION */}
      <div className="dayBook-top">
        <form className="dayBook-form" onSubmit={handleSubmit}>
          <div className="dayBook-form-section">
            {/* Select Branch Input */}
            <div className="dayBook-form-input-fields">
              <label>Select Branch</label>
              <select
                value={branchId}
                onChange={(e) => setBranchId(e.target.value)}
              >
                <option value="">-- All Branches --</option>
                {branches.map((b) => (
                  <option key={b.id || b._id} value={b.id || b._id}>
                    {b.name || b.branchName || `Branch ID: ${b.id || b._id}`}
                  </option>
                ))}
              </select>
            </div>

            {/* Select Date Input */}
            <div className="dayBook-form-input-fields">
              <label>Select Date</label>
              <input
                type="date"
                value={date}
                onChange={(e) => setDate(e.target.value)}
                required
              />
            </div>
          </div>

          <div className="dayBook-form-submit-btn">
            <button type="submit" disabled={loading}>
              {loading ? "Loading..." : "Get Records"}
            </button>
          </div>
        </form>
      </div>

      {/* DOWNLOAD & CONTROLS */}
      <div className="dayBook-controls-bar">
        <div className="dayBook-entries-wrapper">
          <span>Show</span>
          <select
            value={rowsPerPage}
            onChange={(e) => {
              setRowsPerPage(
                e.target.value === "ALL" ? "ALL" : Number(e.target.value)
              );
              setCurrentPage(1);
            }}
            className="dayBook-entries-select"
          >
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
            <option value="ALL">All</option>
          </select>
          <span>entries</span>
        </div>

        <div className="dayBook-pdf-download-btns">
          <button
            type="button"
            className="dayBook-btn-excel"
            onClick={exportToExcel}
          >
            <FileSpreadsheet size={15} /> Download Excel
          </button>
          <button
            type="button"
            className="dayBook-btn-pdf"
            onClick={exportToPDF}
          >
            <FileText size={15} /> Download PDF
          </button>
        </div>
      </div>

      {/* REPORT TABLE SECTION */}
      <div className="dayBook-report-section">
        <h2>Ledgers</h2>

        <div className="dayBook-report-table">
          <table>
            <thead>
              <tr>
                <th>SN.</th>
                <th>Date</th>
                <th>Voucher No</th>
                <th>Voucher Type</th>
                <th>Narration</th>
                <th className="amount-head" style={{ minWidth: "180px" }}>
                  <div className="dayBook-th-data">
                    <span className="amount-title">Amount</span>
                    <div className="dayBook-th-amount">
                      <span>DR</span>
                      <span>CR</span>
                    </div>
                  </div>
                </th>
                <th>Status</th>
              </tr>
            </thead>

            <tbody>
              {!hasSearched ? (
                <tr>
                  <td colSpan="7" style={{ textAlign: "center", padding: "20px" }}>
                    Please select filters and click Get Records
                  </td>
                </tr>
              ) : loading ? (
                <tr>
                  <td colSpan="7" style={{ textAlign: "center", padding: "20px" }}>
                    Loading Day Book Records...
                  </td>
                </tr>
              ) : paginatedData.length > 0 ? (
                paginatedData.map((item, index) => {
                  const { drEntries, crEntries } = splitEntries(item.entries);

                  return (
                    <tr key={item.id || index}>
                      <td>
                        {isShowAll
                          ? index + 1
                          : (currentPage - 1) * limitValue + index + 1}
                      </td>
                      <td>
                        {item.date
                          ? new Date(item.date).toLocaleDateString()
                          : "-"}
                      </td>
                      <td>{item.voucherNo || "-"}</td>
                      <td>{item.voucherType || "-"}</td>
                      <td>{item.narration || "-"}</td>

                      <td>
                        <div className="dayBook-th-amount">
                          <span>
                            {drEntries.length
                              ? drEntries.map((e, i) => (
                                  <div key={i}>{e.debit || 0}</div>
                                ))
                              : "0"}
                          </span>
                          <span>
                            {crEntries.length
                              ? crEntries.map((e, i) => (
                                  <div key={i}>{e.credit || 0}</div>
                                ))
                              : "0"}
                          </span>
                        </div>
                      </td>

                      <td>{item.status || "-"}</td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="7" style={{ textAlign: "center", padding: "20px" }}>
                    No results found
                  </td>
                </tr>
              )}

              {hasSearched && dayBookData.length > 0 && (
                <tr className="totalRow">
                  <td colSpan="5" style={{ textAlign: "right", fontWeight: "bold" }}>
                    TOTAL AMOUNT
                  </td>
                  <td>
                    <div className="dayBook-th-amount" style={{ fontWeight: "bold" }}>
                      <span>₹{totalDebit}</span>
                      <span>₹{totalCredit}</span>
                    </div>
                  </td>
                  <td></td>
                </tr>
              )}
            </tbody>
          </table>

          {/* PAGINATION */}
          {hasSearched && dayBookData.length > 0 && !isShowAll && totalPages > 1 && (
            <div className="pagination">
              <button
                disabled={currentPage === 1}
                onClick={() => setCurrentPage((p) => p - 1)}
              >
                Prev
              </button>

              <span>
                Page {currentPage} of {totalPages}
              </span>

              <button
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage((p) => p + 1)}
              >
                Next
              </button>
            </div>
          )}

          {error && <p className="error-text">{error}</p>}
        </div>
      </div>
    </div>
  );
};

export default DayBook;